import { Reservations } from '@lib/state';

export type CreateCorporateContactRequest = Reservations.CreateCorporateContactRequest;
export type UpdateCorporateContactRequest = Reservations.UpdateCorporateContactRequest;
export type CorporateContactModel = Reservations.CorporateContactModel;
export type CorporateContactType = Reservations.CorporateContactType;
export const CorporateContactType = Reservations.CorporateContactType;
